(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-about-redesign"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('#VoxAbout .story-jump');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  target.open = true;
  target.querySelector('summary').focus({preventScroll:true});
  target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-affiliate-intake"] && !Shopify.designMode) return;
  try {
    
(() => {
  const showConfirmation = () => {
    const confirmation = document.querySelector('[data-vbaf-received]');
    if (!confirmation) return;
    if (location.hash.startsWith('#VoxAffiliate-')) {
      history.replaceState(history.state, '', location.pathname + location.search);
    }
    confirmation.focus({ preventScroll: true });
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showConfirmation, { once: true });
  } else {
    showConfirmation();
  }
  window.addEventListener('load', showConfirmation, { once: true });
  const selector = '.vbaf input[data-vbaf-channel-url]';
  const normalize = (input) => {
    const value = input.value.trim();
    if (!value) return;
    const candidate = /^[a-z][a-z0-9+.-]*:/i.test(value)
      ? value
      : `https://${value.replace(/^\/\//, '')}`;
    try {
      const url = new URL(candidate);
      if (['https:', 'http:'].includes(url.protocol) && url.hostname.includes('.') && !url.username && !url.password) {
        input.value = candidate;
      }
    } catch {}
  };
  document.addEventListener('focusout', (event) => {
    if (event.target.matches(selector)) normalize(event.target);
  });
  document.addEventListener('submit', (event) => {
    const input = event.target.querySelector(selector);
    if (input) normalize(input);
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    const roots = scope.matches?.('[data-vb-contact]') ? [scope] : scope.querySelectorAll('[data-vb-contact]');
    roots.forEach((root) => {
      if (root.dataset.vbcReady) return;
      root.dataset.vbcReady = 'true';
      const topic = root.querySelector('[data-vbc-topic]');
      const status = root.querySelector('[data-vbc-status]');
      if (status) status.focus();
      if (!topic) return;
      const form = topic.form;
      const message = root.querySelector('[data-vbc-message]');
      const companyLabel = root.querySelector('[data-vbc-company-label]');
      const groups = [...root.querySelectorAll('[data-vbc-topics]')];
      const conditionalControls = [...root.querySelectorAll('[data-vbc-topics] input, [data-vbc-topics] select, [data-vbc-topics] textarea')];
      const validateWhitespace = (field) => {
        field.setCustomValidity(field.required && field.value && !field.value.trim() ? field.dataset.emptyError : '');
      };
      const updateTopic = () => {
        const option = topic.selectedOptions[0];
        const key = option.dataset.topic;
        groups.forEach((group) => { group.hidden = !group.dataset.vbcTopics.split(' ').includes(key); });
        conditionalControls.forEach((field) => { field.disabled = !!field.closest('[data-vbc-topics][hidden]'); });
        root.querySelectorAll('[data-vbc-required]').forEach((field) => {
          field.required = !field.disabled && field.dataset.vbcRequired.split(' ').includes(key);
          validateWhitespace(field);
        });
        if (companyLabel) {
          companyLabel.textContent = key === 'dealer' ? companyLabel.dataset.dealerLabel : companyLabel.dataset.affiliateLabel;
          if (key === 'dealer') {
            const star = document.createElement('span');
            star.setAttribute('aria-hidden', 'true');
            star.textContent = ' *';
            companyLabel.append(star);
          }
        }
        root.querySelectorAll('[data-vbc-row]').forEach((row) => {
          row.classList.toggle('vbc-form-row--single', [...row.children].filter((child) => !child.hidden).length === 1);
        });
        if (message) message.placeholder = option.dataset.placeholder;
      };
      topic.addEventListener('change', updateTopic);
      form.addEventListener('input', (event) => {
        if (event.target.matches('[data-vbc-trim]')) validateWhitespace(event.target);
      });
      form.addEventListener('reset', () => { requestAnimationFrame(updateTopic); });
      updateTopic();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-faq"] && !Shopify.designMode) return;
  try {
    
  function initVbFaqManual(section) {
    if (section.dataset.vbFaqInitialized) return;
    section.dataset.vbFaqInitialized = 'true';
    var search = section.querySelector('[data-vb-faq-search]');
    var result = section.querySelector('[data-vb-faq-results]');
    var empty = section.querySelector('[data-vb-faq-empty]');
    var clear = section.querySelector('[data-vb-faq-clear]');
    if (!search) return;

    function filterFaq() {
      var query = search.value.trim().toLowerCase();
      var total = 0;
      section.querySelectorAll('[data-vb-faq-group]').forEach(function(group) {
        var groupTotal = 0;
        group.querySelectorAll('[data-vb-faq-item]').forEach(function(item) {
          var match = !query || item.textContent.toLowerCase().indexOf(query) !== -1;
          item.hidden = !match;
          if (match) groupTotal += 1;
        });
        group.hidden = groupTotal === 0;
        total += groupTotal;
      });
      result.textContent = query ? (total === 1 ? section.dataset.resultOne : section.dataset.resultMany.replace('[count]', total)) : '';
      empty.hidden = total !== 0;
    }

    search.addEventListener('input', filterFaq);
    clear.addEventListener('click', function() {
      search.value = '';
      filterFaq();
      search.focus();
    });
    section.querySelectorAll('.vb-manual__index-link').forEach(function(link) {
      link.addEventListener('click', function() {
        if (search.value) { search.value = ''; filterFaq(); }
      });
    });
  }
  document.querySelectorAll('[data-vb-faq-manual]').forEach(initVbFaqManual);
  document.addEventListener('shopify:section:load', function(event) {
    event.target.querySelectorAll('[data-vb-faq-manual]').forEach(initVbFaqManual);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-parents-guide"]) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('.vbp-contents').forEach(contents => {
      if (contents.dataset.initialized) return;
      contents.dataset.initialized = 'true';
      if (window.matchMedia('(max-width: 599px)').matches) contents.open = false;
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
